export class UsuarioEmailAdministrativoSelect {
    email: string;
    selected: boolean;

    constructor(email: string) {
        this.email = email;
        this.selected = false;
    }
}
